<template>
  <div class="hero-software hero-swiper-btn" id="home">
    <div class="container_f1">
      <!-- Swiper como contenedor principal -->
      <swiper :options="swiperOption" class="hero-swiper">

        <!-- SLIDE 1 -->
        <div class="swiper-slide" :style="bgImg">
          <div class="hero-item">
            <div class="hero-content scroll">
              <h2 class="h1 hero-content-title">
                Construimos software y productos digitales para tu negocio.
              </h2>
              <h6 class="hero-content-subtitle">
                Creamos soluciones a la medida, apps móviles y plataformas web
                diseñadas para impulsar tu crecimiento.
              </h6>
              <a href="#contact" class="btn-cta-primary">
                Hablemos de tu proyecto
              </a>
            </div>

            <div class="hero-thumb">
              <img src="../assets/img/hero/hero-software/img-banner-consultoria-Digital.png" class="img-fluid"
                alt="hero thumb" />
            </div>
          </div>
        </div>

        <!-- SLIDE 2 -->
        <div class="swiper-slide" :style="bgImg">
          <div class="hero-item">
            <div class="hero-content scroll">
              <h2 class="h1 hero-content-title">
                Apps móviles y web listas para escalar.
              </h2>
              <h6 class="hero-content-subtitle">
                Desarrollamos experiencias rápidas, modernas y seguras
                para tus usuarios o tu operación interna.
              </h6>
              <a href="#contact" class="btn-cta-primary">
                Hablemos de tu proyecto
              </a>
            </div>

            <div class="hero-thumb pr-100">
              <img src="../assets/img/hero/hero-software/leonix-desarrollo-Web.jpg" class="img-fluid"
                alt="hero thumb" />
            </div>
          </div>
        </div>

        <!-- SLIDE 3 -->
        <div class="swiper-slide" :style="bgImg">
          <div class="hero-item">
            <div class="hero-content scroll">
              <h2 class="h1 hero-content-title">
                Innovación aplicada a tus procesos.
              </h2>
              <h6 class="hero-content-subtitle">
                Transformamos tu negocio con automatización, datos e
                inteligencia tecnológica.
              </h6>
              <a href="#contact" class="btn-cta-primary">
                Hablemos de tu proyecto
              </a>
            </div>

            <div class="hero-thumb pr-100">
              <img src="../assets/img/hero/hero-software/leonix-Pymes.jpg" class="img-fluid" alt="hero thumb" />
            </div>
          </div>
        </div>

      </swiper>

      <!-- Controles -->
      <div class="swiper-button-prev-1 btn-prev">
        <i class="far fa-angle-left far-icon"></i>
      </div>
      <div class="swiper-button-next-1 btn-next">
        <i class="far fa-angle-right far-icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/css/swiper.min.css'
import { smoothScrollMixin } from '@/mixins/smoothscroll.mixin'

export default {
  mixins: [smoothScrollMixin],
  data() {
    return {
      bgImg: {
        backgroundImage: `url(${require('../assets/img/hero/hero-software/software-shape.png')})`,
      },
      swiperOption: {
        speed: 1500,
        loop: true,
        autoplay: {
          delay: 6000, // un poco más rápido para que se note
          disableOnInteraction: false,
        },
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next-1',
          prevEl: '.swiper-button-prev-1',
        },
      },
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variabls.scss';
@import '../assets/scss/elements/hero-software.scss';

.btn-prev,
.btn-next {
  z-index: 1000;
  position: absolute;
  top: 45%;
  height: 70px;
  width: 70px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.3);
  text-align: center;
}

.btn-prev:hover,
.btn-next:hover {
  background-color: $clr-accent-300;
}

.btn-prev {
  left: 1vw;
}

.btn-next {
  right: 1vw;
}

.far-icon {
  font-weight: 400;
  font-size: 50px;
  line-height: 75px;
  color: whitesmoke;
}

.btn-cta-primary {
  background: #111;
  color: #fff !important;
  padding: 14px 28px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  display: inline-block;
  transition: all .2s ease;
}

.btn-cta-primary:hover {
  background: #000;
  transform: translateY(-2px);
}


</style>
